import React from "react";
import "./CustomDropdownIndicator.scss";

import { components } from "react-select";
import { DropdownIndicatorIcon } from "../VectorIcons/DropdownIndicatorIcon";

export const CustomDropdownIndicator = (props) => {
  const { menuIsOpen, isDisabled } = props.selectProps;

  return (
    <components.DropdownIndicator {...props}>
      <div
        className={`${
          menuIsOpen
            ? "dropdown-indicator-open dropdown-indicator-container"
            : "dropdown-indicator-container"
        } ${isDisabled ? "is-disabled" : ""}`}
      >
        <DropdownIndicatorIcon fill={isDisabled ? "#999999" : "#0098CD"} />
      </div>
    </components.DropdownIndicator>
  );
};
